import { ButtonGroup, FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';
import { postTCard_CheckInReset, postTCard_SetVehicleCollected } from '../../../../Core/Service/communicator-service';
import AppContext from '../../../../App/AppContext';
import formatters from '../../../../Core/Grid/inputFormatter';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';
import DialogComp from '../../../../Core/Modal/dialogModal';

const AddcheckOut = (props) => {
    console.log(props, 'props in AddcheckOut');
    const [state, setState] = useState({
        tCardID: props.tCardsID,
        dateCollected: '',
        closeTCard: true,
        jobProgressDateArrived: props.selectedVehicle?.arrived || '',
        bookingDate: '', //props.bookingDate,
        errors: {}
    });

    const { showToast } = useContext(AppContext);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!state.dateCollected) {
            errors.dateCollected = 'Date is required';
            isValid = false;
        }
        // if (!state.bookingDate && !state.closeTCard) {
        //     errors.bookingDate = 'Date is required';
        //     isValid = false;
        // }

        setState((prev) => ({ ...prev, errors }));
        return isValid;
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            let data = {
                tCardID: state.tCardID,
                dateCollected: state.dateCollected,
                closeTCard: state.closeTCard
            };
            if (!props.selectedVehicle?.arrived && state.jobProgressDateArrived) {
                data.jobProgressDateArrived = state.jobProgressDateArrived;
            }
            if (!state.closeTCard && state.bookingDate) {
                data.bookingDate = state.bookingDate;
            }

            let response = await postTCard_SetVehicleCollected(data);
            if (response.success) {
                showToast(response.message);
                props.onClose(true);
            } else {
                showToast(response.message);
                props.onClose(false);
            }
        }
    };
    console.log(props, 'state in AddcheckOut');

    const handleResetCheckInSubmit = async () => {
        let res;

        res = await postTCard_CheckInReset(props.tCardsID);

        if (res.success) {
            showToast(res.message);
            props.onClose(true);
        } else {
            props.onClose(false);
        }

        setState({ show: false, message: '', mode: '' });
    };

    const handleReset = (mode) => {
        setState((prev) => ({ ...prev, show: true, message: 'Are you sure to reset checkin?' }));
    };

    const hideConfirmationModal = () => {
        setState((prev) => ({ ...prev, show: false, message: '' }));
    };

    return (
        <div>
            <Grid container spacing={2}>
                {!props.hideHeader && (
                    <>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Reg No</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.reg || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Customer</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.cust || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Booking Date</div>
                            <div style={{ fontWeight: 'bold' }}>
                                {props.selectedVehicle?.bd ? formatters.MonthShortFormatter(props.selectedVehicle?.bd) : 'N/A'}
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Status</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.status || 'N/A'}</div>
                        </Grid>
                    </>
                )}
                {props.selectedVehicle?.arrived ? (
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <div style={{ marginBottom: '5px' }}>Arrived Date</div>
                            <div style={{ fontWeight: 'bold' }}>{formatters.DateTimeFormatter(props.selectedVehicle?.arrived) || 'N/A'}</div>
                        </Grid>
                        {props.selectedVehicle?.arrived && (
                            <Grid item xs={4}>
                                <SecondaryButton fullWidth onClick={handleReset}>
                                    Reset
                                </SecondaryButton>
                            </Grid>
                        )}
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <InputLabel shrink>Arrived Date</InputLabel>
                        <TextBox
                            type="datetime-local"
                            name="jobProgressDateArrived"
                            value={state.jobProgressDateArrived}
                            variant="outlined"
                            fullWidth
                            onChange={handleInput}
                            isDisabled={props.selectedVehicle?.arrived}
                        />
                        <span className="mandatoryfields">{state.errors['jobProgressDateArrived']}</span>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <InputLabel shrink error required>
                        Collection Date Time
                    </InputLabel>
                    <TextBox type="datetime-local" name="dateCollected" value={state.dateCollected} variant="outlined" fullWidth onChange={handleInput} />
                    <span className="mandatoryfields">{state.errors['dateCollected']}</span>
                </Grid>

                <Grid item xs={6} style={{ height: '84px' }}>
                    <InputLabel shrink style={{ marginBottom: '10px' }}>
                        Close T-Card
                    </InputLabel>
                    <ButtonGroup color="primary" aria-label="small outlined button group" fullWidth>
                        <SecondaryButton
                            variant={state.closeTCard ? 'contained' : 'outlined'}
                            color="primary"
                            onClick={() => setState((prev) => ({ ...prev, closeTCard: true }))}
                        >
                            Yes
                        </SecondaryButton>
                        <SecondaryButton
                            variant={!state.closeTCard ? 'contained' : 'outlined'}
                            color="primary"
                            onClick={() => setState((prev) => ({ ...prev, closeTCard: false }))}
                        >
                            No
                        </SecondaryButton>
                    </ButtonGroup>
                </Grid>

                {!state.closeTCard && (
                    <Grid item xs={6}>
                        <InputLabel shrink>Re-booking Date</InputLabel>
                        <TextBox
                            type="date"
                            name="bookingDate"
                            value={formatters.DateFormatter(state.bookingDate)}
                            variant="outlined"
                            fullWidth
                            onChange={handleInput}
                        />
                        <span className="mandatoryfields">{state.errors['bookingDate']}</span>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit}>
                        Submit
                    </SecondaryButton>
                </Grid>
            </Grid>
            {state.show && (
                <DialogComp onClose={hideConfirmationModal} title="Warning" maxWidth="sm" fullWidth>
                    <ConfirmationModal message={state.message} handleSubmit={handleResetCheckInSubmit} handleCancel={hideConfirmationModal} />
                </DialogComp>
            )}
        </div>
    );
};

export default AddcheckOut;
